import { Security } from '../components/Security';
import { DOMElement } from '../utils/DOMElement';
import { WordingService } from '../services/WordingService';

/**
 * Security Error Component.
 */
export class SecurityError {
  /**
   * PhoneNumber Error.
   *
   * @type {string}
   */
  static phoneNumberErrorSelector = '#eui-phoneNumber-error';

  /**
   * CSS Class in order to highlight the fact that the input has an error.
   *
   * @type {string}
   */
  static classInputError = 'is-invalid';

  /**
   * Constructor.
   */
  constructor() {
    this.errors = {
      phoneNumber: {
        invalid: WordingService.getWording('phoneNumberError'),
      },
    };
  }

  /**
   * Handle Error display for firstName.
   *
   * @param   {boolean} isValid - Is valid firstName.
   * @param   {string} value - Value of the firstName.
   * @param   {boolean} emptyCheck - If the empty property need to be checked.
   */
  handleErrorPhoneNumber(isValid, value, emptyCheck) {
    if (isValid || (!emptyCheck && !value)) {
      this.hideError(Security.phoneNumberDOMSelector);
    } else {
      this.displayErrorPhoneNumber();
    }
  }

  /**
   * Display Error for phone Number.
   */
  displayErrorPhoneNumber() {
    const errorMsg = this.errors.phoneNumber.invalid;

    this.displayError(SecurityError.phoneNumberErrorSelector, Security.phoneNumberDOMSelector, errorMsg);
  }

  /**
   * Display error.
   *
   * @param   {object} errorSelector - Dom selector.
   * @param   {string} inputSelector - The input error.
   * @param   {string} errorMsg -  - ErrorToDisplay.
   */
  displayError(errorSelector, inputSelector, errorMsg) {
    const errorNodes = document.querySelectorAll(errorSelector);
    const inputNodes = document.querySelectorAll(inputSelector);

    for (let i = 0; i < errorNodes.length; i += 1) {
      const errorNode = errorNodes[i];

      if (errorMsg && errorNode) {
        errorNode.innerHTML = errorMsg;
      }
    }

    for (let i = 0; i < inputNodes.length; i += 1) {
      const inputNode = inputNodes[i];

      DOMElement.addClass(SecurityError.classInputError, inputNode);
      inputNode.setAttribute('aria-invalid', 'true');
      inputNode.setAttribute('aria-describedby', 'eui-phoneNumber-error');
    }
  }

  /**
   * Hide error.
   *
   * @param   {string} inputSelector - The message error.
   */
  hideError(inputSelector) {
    const inputNodes = document.querySelectorAll(inputSelector);

    // remove css class to remove input highlighting
    for (let i = 0; i < inputNodes.length; i += 1) {
      const inputNode = inputNodes[i];

      DOMElement.removeClass(SecurityError.classInputError, inputNode);
      inputNode.setAttribute('aria-invalid', 'false');
      inputNode.removeAttribute('aria-describedby');
    }
  }
}
